import React from 'react';
import { Pagination } from 'react-bootstrap';

interface ReviewsPaginatorProps {
  // add paginator props here
  reviewsPerPage: number;
  totalReviews: number;
  paginate;
  currentPage: number;
}

const ReviewsPaginator: React.FC<ReviewsPaginatorProps> = ({
  reviewsPerPage,
  totalReviews,
  paginate,
  currentPage,
}: ReviewsPaginatorProps) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalReviews / reviewsPerPage); i++) {
    pageNumbers.push(i);
  }

  let pageStepSlice =
    pageNumbers.length <= 5
      ? pageNumbers
      : currentPage >= pageNumbers.length - 4
      ? pageNumbers.slice(pageNumbers.length - 5, currentPage + 4)
      : pageNumbers.slice(currentPage - 1, currentPage + 4);

  return (
    <nav
      className='paginator-nav'
      style={{
        listStyle: 'none',
        display: 'flex',
        justifyContent: 'space-evenly',
        width: '100%',
        margin: '0 auto',
        padding: '2.5rem 0',
      }}
    >
      <Pagination.First
        onClick={() => paginate(1)}
        disabled={currentPage === 1 ? true : false}
      />
      <Pagination.Prev
        onClick={() => paginate(currentPage === 1 ? 1 : currentPage - 1)}
        disabled={currentPage === 1 ? true : false}
      />
      <Pagination.Ellipsis
        onClick={() =>
          paginate(
            currentPage <= 5 || pageNumbers.length <= 5
              ? currentPage
              : currentPage - 5
          )
        }
        disabled={currentPage <= 5 ? true : false}
      />
      {pageStepSlice.map((number) => (
        <Pagination.Item
          key={number}
          active={currentPage === number}
          onClick={() => paginate(number)}
        >
          {number}
        </Pagination.Item>
      ))}
      <Pagination.Ellipsis
        onClick={() =>
          paginate(
            currentPage >= pageNumbers.length - 5 || pageNumbers.length <= 5
              ? pageNumbers.length
              : currentPage + 5
          )
        }
        disabled={currentPage >= pageNumbers.length - 4 ? true : false}
      />
      <Pagination.Next
        onClick={() =>
          paginate(
            currentPage === pageNumbers.length
              ? pageNumbers.length
              : currentPage + 1
          )
        }
        disabled={currentPage === pageNumbers.length ? true : false}
      />
      <Pagination.Last
        onClick={() => paginate(pageNumbers.length)}
        disabled={currentPage === pageNumbers.length ? true : false}
      />
    </nav>
  );
};

export default ReviewsPaginator;
